import { render, staticRenderFns } from "./MultiVueSelect.vue?vue&type=template&id=d1e3470c&"
import script from "./MultiVueSelect.vue?vue&type=script&lang=js&"
export * from "./MultiVueSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports